<span (click)="logout()" class="logout-btn">
  Log ud
</span>
